import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLibra = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 28.6667H30M6 23.3333H11.7391M24.2609 23.3333H30M24.0392 22.8692C26.0697 21.1158 27.3333 18.4914 27.3333 15.5584C27.3333 10.2795 23.1547 6 18 6C12.8453 6 8.66667 10.2795 8.66667 15.5584C8.66667 18.4909 9.93085 21.1149 11.9608 22.8683",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLibra;
